// extracted by mini-css-extract-plugin
export var dropdown = "_rf-0";
export var imageWrapper = "_rf-3";
export var itemNameContainer = "_rf-1";
export var productImage = "_rf-2";
export var spinnerWrapper = "_rf-4";